import { render, staticRenderFns } from "./FormBody.vue?vue&type=template&id=09cf0dc3&scoped=true&"
import script from "./FormBody.vue?vue&type=script&lang=ts&"
export * from "./FormBody.vue?vue&type=script&lang=ts&"
import style0 from "./FormBody.vue?vue&type=style&index=0&id=09cf0dc3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cf0dc3",
  null
  
)

export default component.exports